/* One eligibility and category matcher for the Special Prices department cards and
   their combined destinations. A product is placed by its own tags first
   (scat: tags, then other meaningful tags), then by words in its title and
   handle. Internal collection names do not divide a shopper category, so a
   card gathers every eligible product of that kind across collections.
   Each category has one home: jewellery lives under Women / Men, home scents
   under Fragrances, bath lines under Beauty. Product IDs are deduplicated by
   the index loader. Shared by the storefront and the build script. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SaleCategoryRules = factory();
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var infoCache = typeof WeakMap === 'function' ? new WeakMap() : null;

  function key(s) {
    var k = String(s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]/g, '');
    return ({
      sneakersandtrainers: 'sneakers', belt: 'belts', crossbody: 'crossbodybags', totebags: 'totebag',
      clutchbag: 'clutches', clutchbags: 'clutches', diffusers: 'diffuser', fashionjewelry: 'fashionjewellery',
      tray: 'trays', shoulderbag: 'shoulderbags', handbag: 'handbags', minibag: 'minibags', bucketbag: 'bucketbags'
    })[k] || k;
  }
  // Singular form, so a "Shoulder Bag" tag meets the "Shoulder Bags" card.
  function one(k) { return k.replace(/(ies)$/, 'y').replace(/s$/, ''); }

  /* Other tag spellings that mean exactly the same card. */
  var aliases = {
    shirtsandblouses: ['shirts', 'blouses', 'womenshirts'],
    loafersanddrivers: ['loafers', 'drivers'],
    abayasandkaftans: ['kaftans', 'abayas', 'kaftansandabayas', 'abaya', 'kaftan'],
    knitwearandsweaters: ['sweatersandcardigans', 'pullovers', 'pullover'],
    womenfragrance: ['womenfragrances', 'womensfragrance', 'womensfragrances', 'beautywomenfragrances'],
    menfragrance: ['menfragrances', 'mensfragrance', 'mensfragrances', 'beautymenfragrances'],
    shoulderbags: ['hobobag', 'hobos', 'hobobags'],
    handbags: ['satchelbag', 'satchels', 'satchel', 'tophandlebag'],
    walletsandcardholders: ['menwallet', 'smallwallet', 'cardcase', 'cardholder', 'wallets'],
    swimwearandnightwear: ['pyjama', 'pyjamas', 'kidsandteensboyswimwear', 'kidsandteensswimwear'],
    changingbags: ['changingbag', 'diaperbag', 'newbornchangingbag'],
    strollersandaccessories: ['strollers', 'strollerpack', 'newbornstroller'],
    sunglasscases: ['sunglassescover', 'sunglasscover'],
    pantsandshorts: ['shorts', 'bottoms'],
    bracelets: ['braceletes', 'ladiesbracelet']
  };

  function info(p) {
    if (infoCache && infoCache.has(p)) return infoCache.get(p);
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase().trim(); });
    var cats = tags.filter(function (t) { return /^scat:\s*/.test(t) && !/^scat:\s*new\s*in/.test(t); }).map(function (t) { return key(t.replace(/^scat:\s*/, '')); });
    var type = key(p.product_type), words = ((p.handle || '').replace(/-/g, ' ') + ' ' + (p.title || '')).toLowerCase();
    var vendor = String(p.vendor || '').toLowerCase().trim();
    if (vendor) words = words.split(vendor).join(' ');
    // Kids by type, or by tag on fashion only: a perfume tagged "Beauty Kids
    // fragrances" is still a perfume.
    var kids = type === 'kidsfashion' || !/perfumes|makeup|home|linen|food|luggage|watches/.test(type) && tags.some(function (t) { return /\bkids\b|\bnewborn\b/.test(t); });
    /* Gender from the product's own tags first ("Women", "Women All Bags",
       "Men's All Accessories", "Mens Watches"); only when the tags name no
       gender do the title words decide. Tagged for both = for both. */
    var tagWomen = tags.some(function (t) { return /^(womens?|women's|ladies|female)\b|who:\s*for her|^lingerie$/.test(t); });
    var tagMen = tags.some(function (t) { return /^(mens?|men's|male)\b|who:\s*for him/.test(t); });
    var wordWomen = /\bwomen('?s)?\b|\bladies\b|\bpour femme\b|\bfor her\b/.test(words), wordMen = /\bmen('?s)?\b|\bpour homme\b|\bfor him\b/.test(words);
    var women, men;
    if (tagWomen || tagMen) { women = tagWomen; men = tagMen; } else { women = wordWomen; men = wordMen; }
    if (wordWomen && !wordMen && tagWomen) men = false;
    if (wordMen && !wordWomen && tagMen) women = false;
    if (type === 'womensfashion' || type === 'womenfashion' || type === 'lingerie') { women = true; men = false; }
    if (type === 'mensfashion') { men = true; women = false; }
    if (kids) { women = false; men = false; }
    var unisex = !kids && (tags.indexOf('unisex') >= 0 || /\bunisex\b/.test(words) || (women && men));
    // Hyphens read as spaces, as in the handle: "T-Shirt" -> "t shirt".
    var titleWords = String(p.title || '').toLowerCase().replace(/-/g, ' ');
    if (vendor) titleWords = titleWords.split(vendor).join(' ');
    var result = { tags: tags, cats: cats, type: type, words: words, titleWords: titleWords, title: String(p.title || '').toLowerCase(), kids: kids, women: women, men: men, unisex: unisex, neutral: !kids && !women && !men };
    if (infoCache) infoCache.set(p, result);
    return result;
  }

  function eligible(p) {
    return p.available === true && (p.tags || []).some(function (t) { return String(t).trim().toUpperCase() === 'PROMOCEGID'; });
  }

  function homeFragrance(d) {
    if (/massage.{0,20}candle|flowerbomb.{0,30}candle/.test(d.words)) return false;
    return d.cats.some(function (c) { return ['homefragrance', 'candles', 'diffuser', 'roomsprays'].indexOf(c) >= 0; }) || d.tags.some(function (t) {
      return /home\s*fragranc|home\s*candle|linen\s*candle|^candles?$|^diffusers?$|room\s*spray|fragrance\s*sticks?/.test(t);
    }) || /\b(candles?|diffusers?|room sprays?|fragrance sticks?)\b/.test(d.words);
  }

  function perfume(d) {
    // Creams, washes and masks that mention a scent are care, not perfume -
    // unless the product's own scat tag files it as a fragrance.
    if (!d.cats.some(function (c) { return ['fragrance', 'womenfragrance', 'menfragrance', 'nichefragrances'].indexOf(c) >= 0; }) &&/\b(creams?|serums?|lotions?|shampoos?|conditioners?|masks?|cleans\w*|scrubs?|soaps?|shower|bath|gels?|toners?|oils?|balms?|deodorants?|moisturi\w*|sunscreens?|spf)\b/.test(d.title) &&
      !/\b(edp|edt|eau de|parfum|perfume|cologne|extrait|body mist|body splash)\b/.test(d.title)) return false;
    return d.cats.some(function (c) { return ['fragrance', 'womenfragrance', 'menfragrance', 'nichefragrances'].indexOf(c) >= 0; }) ||
      d.tags.some(function (t) { return /fragrances?$|^perfumes?$/.test(t); }) ||
      /\b(edp|edt|eau de (parfum|toilette|cologne|senteur)|extrait|parfum|perfume|cologne|body splash|body mist)\b/.test(d.words);
  }

  function watch(d) {
    // "Watch Collector" swimwear is clothing, not a watch.
    if (/fashion$|lingerie/.test(d.type)) return false;
    if (/\bwatch box(es)?\b|\bwatch (roll|case|winder)s?\b/.test(d.words)) return false;
    if (/\bwatch(es)?\b|timepiece|chronograph/.test(d.title)) return true;
    // The "Watches" product type also holds the watch brands' bracelets,
    // rings, keyrings, wallets and cardholders: a piece of jewellery or
    // leather named as such is not a watch.
    if (/\b(bracelets?|bangles?|necklaces?|pendants?|rings?|earrings?|cufflinks?|brooch(es)?|key ?(rings?|holders?|chains?)|pens?|wallets?|card ?(holders?|cases?)|jewell?e?ry sets?)\b/.test(d.title)) return false;
    if (d.cats.indexOf('luxurytimepieces') >= 0 || d.cats.indexOf('fashiontimepieces') >= 0) return true;
    if (d.tags.some(function (t) { return /^((mens?|womens?|fashion|luxury) )?watch(es)?$/.test(t); })) return true;
    // The type alone decides only for an item with no category tag of its
    // own; a wallet filed under "Watches" carries "Wallets & cardholders".
    return d.type === 'watches' && !d.cats.length;
  }

  function jewellery(d) {
    if (['home', 'linen', 'luggage', 'perfumesandcosmetics', 'makeupandskincare'].indexOf(d.type) >= 0 || /\b(trinket|jewell?ery|jewell?ry) boxes?\b|\bkeyrings?\b|\bkey rings?\b|\bnapkin rings?\b/.test(d.words)) return false;
    if (d.kids && /\b(tops?|shirts?|dresses?)\b/.test(d.words)) return false;
    if (watch(d)) return false;
    return d.cats.some(function (c) { return ['fashionjewellery', 'bracelets', 'necklaces', 'earrings', 'rings', 'anklets', 'cufflinks'].indexOf(c) >= 0; }) ||
      d.tags.some(function (t) { return /\b(jewell?ery|jewell?ry|bracelets?|necklaces?|earrings?|anklets?)\b/.test(t); }) ||
      /\b(bracelets?|bangles?|necklaces?|earrings?|pendants?|rings?|anklets?|brooch(es)?|cufflinks?)\b/.test(d.words);
  }

  /* Words in the title/handle that put a product on a card when its tags do
     not. Tested against the title only unless noted. */
  var fallback = {
    candles: /\bcandles?\b/, diffuser: /\bdiffusers?\b|fragrance sticks?\b|\breed diffusers?\b/, roomsprays: /\bsprays?\b|parfum d ambiance/, earrings: /\bearrings?\b/,
    necklaces: /\bnecklaces?\b|\bpendants?\b/, bracelets: /\bbracelets?|\bbangles?\b|\brondelles?\b|\banklets?\b/, rings: /\brings?\b/, anklets: /\banklets?\b/,
    sleepsuits: /\bsleepsuits?\b|\bbabysuits?\b/, rompers: /\brompers?\b/, babynest: /\bbaby nests?\b/,
    strollersandaccessories: /\bstrollers?\b|\bpushchairs?\b|\bstroller pack\b|\bcolor pack\b|\bnewborn pack\b/, carseats: /\bcar seats?\b/,
    hoodiesandsweatshirt: /\bhoodies?\b|\bsweatshirts?\b/, sweatshirtsandhoodies: /\bhoodies?\b|\bsweatshirts?\b/,
    pantsandshorts: /\bshorts?\b|\bpants\b|\btrousers?\b|\bjoggers?\b/, joggingsuits: /\bjogging suits?\b|\btracksuits?\b/, pants: /\bpants?\b/, nightdress: /\bnightdress(es)?\b/, blanket: /\bblankets?\b/,
    ballerinas: /\bballerinas?\b/, leggings: /\bleggings\b/,
    swimwear: /\bswimwear\b|\bswimming\b|\bbikini|\bswim shorts?\b/,
    shirtsandblouses: /\bblouses?\b|\bshirt\b(?!.*\bpolo\b)/,
    shirts: /\bshirts?\b/,
    coatsandjackets: /\bcoats?\b|\bjackets?\b/, jacketsandcoats: /\bcoats?\b|\bjackets?\b/,
    sweatersandcardigans: /\bsweaters?\b|\bcardigans?\b|\bpullovers?\b|\bknit(wear)?\b/, knitwearandsweaters: /\bsweaters?\b|\bknitwear\b|\bpullovers?\b|\bcardigans?\b|\bturtlenecks?\b/,
    nightwearandloungewear: /\bloungewear\b|\bpyjamas?\b|\bpajamas?\b|\brobes?\b/,
    pyjamasandloungewear: /\bloungewear\b|\bpyjamas?\b|\bpajamas?\b|\bnightwear\b/, bras: /\bbras?\b/, panties: /\bpant(y|ies)\b|\bbrazilian\b|\bbriefs?\b|\bthongs?\b|\bshapers?\b/,
    abayasandkaftans: /\bkaftans?\b|\babayas?\b|\bjalabiyas?\b/,
    boots: /\bboots?\b|\bbooties\b/, broguesandoxfords: /\bbrogues?\b|\boxfords?\b/, oxfordshoes: /\boxfords?\b/,
    dressshoes: /\blace up.{0,20}shoes?\b|\bclassic shoes?\b|\bdress shoes?\b|\bderby\b|\bderbies\b|\bleather (classic )?shoes?\b/,
    slidesandsandals: /\bslides?\b|\bsandals?\b|\bslippers?\b|\bthong strap\b|\bflip flops?\b/,
    loafersanddrivers: /\bloafers?\b|\bdrivers?\b|\bmoccasins?\b/,
    handbags: /\bhandbags?\b|\bhand bags?\b|\bsatchels?\b|\btop handle\b/, clutches: /\bclutch(es)?\b|\bpouch(es)?\b/, bagcharms: /\bbag charms?\b|\bkey ?chains?\b/,
    cosmeticbags: /\bcosmetic bags?\b|\bbeauty bags?\b|\bempty bags?\b|\bmake ?up bags?\b|\btoiletry bags?\b/, shopperbags: /\bshopper\b/, pens: /\bpens?\b|\bballpoint\b/,
    spinnersuitcases: /\bspinner\b|\bsuitcases?\b|\btrolley\b/,
    travellocks: /\blocks?\b|\bpadlocks?\b/, travelpillows: /\bpillows?\b|\bneck rest\b/,
    packingcubesandorganisers: /\bpack it\b|\bpacking cubes?\b|\bfolding.{0,25}roll\b|\btoiletry case\b|\borgani[sz]ers?\b|\btech kit\b/,
    duffelbags: /\bduff(el|le)\b/,
    travelaccessories: /\bprayer mat\b|\bluggage.{0,15}(covers?|straps?|tags?)\b|\btravel adapters?\b|\btravel pouch\b/,
    jarsandstorage: /\bjars?\b|\bstorage\b|\bkeepsake box\b/, photoframes: /\bphoto frames?\b|\bpicture frames?\b/,
    trays: /\btrays?\b/, popcorn: /\bpopcorn\b/,
    skincare: /\bserums?\b|\bampoules?\b|\btoners?\b|\bcleansing\b|\bmoisturi[sz]/,
    facemask: /\bface masks?\b|\bsheet masks?\b|\bnose patch/, lipbalm: /\blip balms?\b/,
    haircare: /\bshampoo\b|\bconditioner\b|\bhair (care|mask|oil|serum)/,
    poloshirts: /\bpolo\b/,
    tshirts: /\bt shirts?\b|\btshirts?\b/, dresses: /\bdress(es)?\b/, gowns: /\bgowns?\b/, jeans: /\bjeans\b/, skirts: /\bskirts?\b/,
    shorts: /\bshorts\b|\bbermudas?\b/, trousers: /\btrousers?\b|\bpants?\b|\bjoggers?\b|\bchinos?\b/, blazers: /\bblazers?\b|\bsuits?\b/, capsandhats: /\bcaps?\b(?! sleeves?)|\bhats?\b/,
    cufflinks: /\bcufflinks?\b/, socks: /\bsocks?\b/, belts: /\bbelts?\b/, scarves: /\bscarves?\b|\bscarfs?\b|\bshawls?\b/,
    hairaccessories: /\bhair ?(bands?|brush(es)?|ornaments?|clips?|pins?|accessor(y|ies)|ties?)\b|\bheadbands?\b|\bscrunchies?\b|\bornaments?\b/,
    sunglasscases: /\bsunglass(es)? (covers?|cases?|straps?)\b/,
    shoulderbags: /\bshoulder bags?\b|\bhobo\b/, minibags: /\bmini bags?\b/, bucketbags: /\bbucket bags?\b/,
    totebag: /\btote\b/, backpacks: /\bbackpacks?\b/, crossbodybags: /\bcrossbody\b|\bcross body\b|\bmessenger\b|\bphone.{0,12}bag\b/,
    crossbody: /\bcrossbody\b|\bcross body\b|\bmessenger\b|\bphone.{0,12}bag\b/,
    waistbagsandslings: /\bwaist (bags?|packs?)\b|\bbelt bags?\b|\bsling( packs?| bags?)?\b|\bbum bags?\b/,
    walletsandcardholders: /\bwallets?\b|\bcard\s*holders?\b|\bcard cases?\b/,
    vases: /\bvases?\b/, bowls: /\bbowls?\b/, biscuits: /\bbiscuits?\b/, coffee: /\bcoffee\b/, tea: /\btea\b/,
    bathrug: /\bbath (rug|mat)/, towel: /\btowels?\b/, bathrobe: /\bbathrobes?\b/, pillows: /\bpillows?\b/,
    slippers: /\bslippers?\b/, sneakers: /\bsneakers?\b|\btrainers?\b|\bcrib shoes\b/, loafers: /\bloafers?\b/,
    cabin: /\bcarry on\b|\bcabin\b/,
    sandals: /\bsandals?\b/, pumpsandheels: /\bpumps?\b|\bheels?\b/, balletandflats: /\bballet\b|\bflats\b/, mules: /\bmules?\b/,
    keyrings: /\bkeyrings?\b|\bkey rings?\b|\bkey holders?\b/,
    jewelleryboxes: /\b(jewell?ery|jewell?ry|trinket) boxes?\b/,
    dinnerware: /\bplatters?\b|\bplates?\b|\bdinnerware\b|\bbread baskets?\b|\bserving\b|\btongs\b|\btabletop\b|\bminhardise\b/,
    stands: /\bstands?\b/,
    homeaccessories: /\bornaments?\b|\bdomes?\b|\bmirrors?\b|\btrinket\b|\bjewell?e?ry box\b|\bdecorat(ion|ive)\b|\btable cent(er|re)\b|\bcenterpiece\b|\bsculptures?\b|\bfigurines?\b|\btrolleys?\b/,
    framedwallart: /\bwall art\b|\bartwork\b|\bcanvas\b|\bembroidered art\b|\bframed\b/,
    accessoriesandtoys: /\bburp cloths?\b|\bmittens?\b|\bteeth(ing|er)\b|\btoys?\b|\bhelmets?\b|\btrikes?\b|\bsunglasses\b|\bcaps?\b|\bhats?\b|\bgiraffe\b|\brattles?\b/,
    feedingessentials: /\bplates?\b|\bbowls?\b|\bcups?\b|\bbottles?\b|\bbibs?\b|\bspoons?\b|\bfeeding\b/,
    changingbags: /\bchanging bags?\b|\bdiaper bags?\b|\bmommy bags?\b|\bnappy\b/,
    bagsandaccessories: /\bbags?\b|\bpouch(es)?\b|\bwatch box(es)?\b|\bsunglass(es)? (covers?|cases?|straps?)\b|\bphone (bag|case|pouch)\b|\bstrap sets?\b/,
    swimwearandnightwear: /\bswim\b|\bswimwear\b|\bpyjamas?\b|\bpajamas?\b|\bnightwear\b/,
    tops: /\bt ?shirts?\b|\btops?\b|\bpolos?\b|\bblouses?\b|\bshirts?\b/,
    makeup: /\bpalettes?\b|\beyeshadows?\b|\bblush(er)?\b|\bcontour\b|\bhighlight(er)?\b|\bbronzers?\b|\bmascaras?\b|\beyeliners?\b|\bbrows?\b|\blip(stick| gloss| liner)s?\b|\bfoundations?\b|\bconcealers?\b|\bprimers?\b/,
    giftset: /\bgift ?sets?\b|\bsets?\b|\bcoffrets?\b/,
    fragrance: /\b(edp|edt|eau de (parfum|toilette|cologne|senteur)|extrait|parfum|perfume|cologne|body splash|body mist)\b/
  };
  fallback.oxfordshoes = /\boxfords?\b/;

  /* Categories an ungendered accessory may join under Women. */
  var womenNeutral = ['fashionjewellery', 'bracelets', 'necklaces', 'earrings', 'rings', 'anklets', 'scarves', 'hairaccessories',
    'belts', 'bagcharms', 'cosmeticbags', 'hats', 'sunglasscases', 'fashiontimepieces', 'luxurytimepieces'];
  var menNeutral = ['fashiontimepieces', 'luxurytimepieces', 'keyrings', 'pens', 'cufflinks', 'capsandhats'];
  var looseTypes = /^$|leathergoods|fashionaccessories|watches|autoimport|jewel/;

  function inDepartment(d, rule, category) {
    var dep = rule.department;
    if (dep === 'kids') return d.kids;
    if (d.kids) return false;
    if (dep === 'women' || dep === 'men') {
      if (/perfumesandcosmetics|makeupandskincare|home|linen|foodandbeverages/.test(d.type)) return false;
      // Luggage & Travel has no belt card, so luggage-brand belts join Men /
      // Women; everything else luggage-typed stays in Luggage & Travel.
      if (d.type === 'luggage' && !/\bbelts?\b/.test(d.title)) return false;
      if (dep === 'women') return d.women || d.unisex || (d.neutral && looseTypes.test(d.type) && womenNeutral.indexOf(category) >= 0);
      return d.men || d.unisex || (d.neutral && looseTypes.test(d.type) && menNeutral.indexOf(category) >= 0);
    }
    if (dep === 'fragrances') return /perfumesandcosmetics/.test(d.type) || homeFragrance(d) || perfume(d) && /makeupandskincare|womensfashion|mensfashion|autoimport/.test(d.type);
    if (dep === 'beauty') return /makeupandskincare|perfumesandcosmetics/.test(d.type) || d.tags.some(function (t) { return /beauty|skincare|skin care|personal care/.test(t); }) && !/kidsfashion|womensfashion|mensfashion/.test(d.type);
    // Every adult bag lives here, whatever internal type it was filed under.
    if (dep === 'bags') return /leathergoods|fashionaccessories|autoimport/.test(d.type) ||
      /fashion$|lingerie|watches/.test(d.type) && /\b(bags?|clutch(es)?|totes?|handbags?|backpacks?|satchels?|hobos?|briefcases?|pouch(es)?)\b/.test(d.title);
    if (dep === 'luggage') return d.type === 'luggage';
    if (dep === 'home') return ['home', 'linen', 'outoftheblue'].indexOf(d.type) >= 0 && !homeFragrance(d);
    if (dep === 'gourmet') return d.type === 'foodandbeverages';
    return true;
  }

  function tagMeans(d, wanted) {
    return d.tags.some(function (t) {
      var k = key(t);
      return wanted.some(function (w) {
        if (one(k) === one(w)) return true;
        // "Women Earrings" means Earrings: the whole rest after a department
        // word must be the category, so it can never also mean "Rings".
        // Department words may stack ("Beauty Selfcare Bodycare").
        var m, rest = k;
        while ((m = rest.match(/^(womens|women|ladies|mens|men|kids|home|linen|beauty|selfcare|cosmetics|babygirl|babyboy|baby|girls|girl|boys|boy|newborn|and|furniture|teens|all|luggage)(.+)$/))) {
          rest = m[2];
          if (one(rest) === one(w)) return true;
        }
        return false;
      });
    });
  }

  /* A broad card never repeats the specific cards beside it in the same tab:
     Sneakers leaves Running Shoes to its own card, Beddings leaves Pillows
     and Towels, Travel Accessories leaves Packing Cubes, and so on. */
  var leavesTo = {
    sneakers: ['runningshoes'], sneakersandtrainers: ['runningshoes'],
    trousers: ['sportswear'], slidesandsandals: ['traditionalfootwear'],
    sets: ['sleepsuits', 'rompers'], pantsandshorts: ['jeansandpants'],
    bagsandaccessories: ['changingbags', 'phonecases', 'backpacks'], totebag: ['shopperbags'], crossbodybags: ['phonecases'],
    skincare: ['facemask', 'kbeauty'],
    travelaccessories: ['packingcubesandorganisers', 'toiletries', 'travelpillows', 'travellocks', 'chargerandusb', 'healthandsafety'],
    beddings: ['pillows', 'towel', 'bathrug']
  };
  function matches(p, rule) {
    if (!matchesOwn(p, rule)) return false;
    var others = leavesTo[key(rule.label)];
    return !others || !others.some(function (label) {
      return matchesOwn(p, { id: rule.id, label: label, department: rule.department, tab: rule.tab, material: rule.material });
    });
  }

  // scat tags that name a department or range, not a shopping category.
  var perfumeCats = ['fragrance', 'womenfragrance', 'menfragrance', 'nichefragrances', 'giftset'];
  var broadCats = ['hardluggage', 'softluggage', 'luggage', 'newin', 'homeandlinen', 'home', 'linen', 'beauty', 'kidsandteens'];
  // Card -> broader scat tags whose products it may take by their words:
  // a sub-kind of what the tag names, never a sibling category.
  var refines = {
    runningshoes: ['sneakers'],
    bracelets: ['fashionjewellery'], necklaces: ['fashionjewellery'], earrings: ['fashionjewellery'],
    rings: ['fashionjewellery'], anklets: ['fashionjewellery'], cufflinks: ['fashionjewellery'],
    trousers: ['trousersandshorts'], shorts: ['trousersandshorts'], jeans: ['trousersandshorts'],
    tshirts: ['tops'], hoodiesandsweatshirt: ['tops'], sweatersandcardigans: ['tops'],
    minibags: ['shoulderbags', 'handbags', 'crossbodybags'],
    jeansandpants: ['pantsandshorts'], skirtsandshorts: ['pantsandshorts'],
    sleepsuits: ['sets'], rompers: ['sets'], joggingsuits: ['sets'],
    waistbagsandslings: ['crossbody', 'crossbodybags'], dressshoes: ['oxfordshoes'],
    makeup: ['eyeshadow', 'eyebrows', 'bronzerandhighlighter', 'lipglossandtint'],
    pillows: ['beddings'], leggings: ['jeansandpants', 'pants'], backpacks: ['bagsandaccessories'],
    shopperbags: ['totebag'], spinnersuitcases: ['cabin', 'mediumluggage', 'largeluggage', 'extralargeluggage']
  };

  function matchesOwn(p, rule) {
    if (!eligible(p)) return false;
    var d = info(p), category = key(rule.label);
    if (!inDepartment(d, rule, category)) return false;
    var wanted = [category].concat(aliases[category] || []);

    /* Perfume splits once into Niche or Designer (by the product's niche tag),
       then by who it is for: tagged for both, or for neither, is unisex.
       Gift sets keep their own card under Home Fragrance & Gifts. */
    var perfumeCards = ['nicheforher', 'nicheforhim', 'unisexniche', 'womenfragrance', 'menfragrance', 'unisexfragrance', 'fragrance', 'nichefragrances'];
    if (perfumeCards.indexOf(category) >= 0) {
      if (rule.department !== 'fragrances' || homeFragrance(d) || !perfume(d)) return false;
      // A product whose own category tag names skincare, a body wash or the
      // like is not a perfume, whatever scent its title mentions.
      if (d.cats.some(function (c) { return perfumeCats.indexOf(c) < 0 && broadCats.indexOf(c) < 0; })) return false;
      if (/\bgift ?sets?\b|\bsets?\b/.test(d.title) || d.cats.indexOf('giftset') >= 0) return false;
      var niche = d.cats.indexOf('nichefragrances') >= 0 || d.tags.some(function (t) { return /\bniche\b/.test(t); });
      // Its own "Women / Men Fragrance" tag decides who it is for; the
      // gender tags only when it carries neither.
      var tagHer = d.cats.indexOf('womenfragrance') >= 0, tagHim = d.cats.indexOf('menfragrance') >= 0;
      var forHer = tagHer || tagHim ? tagHer && !tagHim : d.women && !d.men;
      var forHim = tagHer || tagHim ? tagHim && !tagHer : d.men && !d.women;
      var unisex = !forHer && !forHim;
      if (category === 'nicheforher') return niche && forHer;
      if (category === 'nicheforhim') return niche && forHim;
      if (category === 'unisexniche') return niche && unisex;
      if (category === 'womenfragrance') return !niche && forHer;
      if (category === 'menfragrance') return !niche && forHim;
      if (category === 'unisexfragrance') return !niche && unisex;
      if (category === 'nichefragrances') return niche;
      if (category === 'fragrance') return true;
    }
    if (category === 'homefragrance') return homeFragrance(d);
    if (['candles', 'diffuser', 'roomsprays'].indexOf(category) >= 0) {
      return homeFragrance(d) && (d.cats.indexOf(category) >= 0 || fallback[category].test(d.words + ' ' + d.tags.join(' ')));
    }
    if (category === 'fashionjewellery') return jewellery(d);
    if (['bracelets', 'necklaces', 'earrings', 'rings', 'anklets', 'cufflinks'].indexOf(category) >= 0) {
      if (!jewellery(d)) return false;
    }
    if (rule.material) {
      var material = d.tags.some(function (t) { return /\b(hard|soft)\b.{0,12}luggage|luggage.{0,12}\b(hard|soft)\b/.test(t); }) || /\b(hard|soft)(side|shell)?\b.{0,12}luggage/.test(d.words);
      var mine = d.tags.some(function (t) { return t.indexOf(rule.material + ' luggage') >= 0 || t.indexOf('luggage ' + rule.material) >= 0; }) || d.words.indexOf(rule.material + ' luggage') >= 0;
      // A suitcase that names no shell type is treated as hard shell.
      if (!(mine || !material && rule.material === 'hard')) return false;
      if (/\b(tags?|straps?|covers?|locks?|bags?|packs?)\b/.test(d.title)) return false;
    }
    if (['fashiontimepieces', 'luxurytimepieces'].indexOf(category) >= 0) {
      if (!watch(d) || /\b(shorts?|trousers?|shirts?|swimwear|bras?|panties|bags?)\b/.test(d.title)) return false;
      var luxury = d.cats.indexOf('luxurytimepieces') >= 0 || d.tags.indexOf('luxury watches') >= 0;
      return category === 'luxurytimepieces' ? luxury : !luxury;
    }
    if (watch(d) && rule.department !== 'kids') return false;
    /* A product's own category tag decides its card. A bra tagged "Bras"
       never lands on Panties, a T-shirt tagged "T-Shirts" never on
       Trousers, a dressing gown never on Gowns - whatever words its title
       or other tags carry. Words and side-tags only place products whose
       category tag is broad, and only into the cards that refine it
       (refines: card -> the broad tags it may draw from). */
    var own = d.cats.filter(function (c) { return broadCats.indexOf(c) < 0; });
    if (own.length && !own.some(function (c) { return wanted.indexOf(c) >= 0 || (refines[category] || []).indexOf(c) >= 0; })) return false;
    var bagTitle = /\b(bags?|backpacks?|totes?|clutch(es)?|pouch(es)?|wallets?|cases?|covers?)\b/.test(d.title);
    // Shoe and underwear cards hold shoes and underwear only: "Oxford" nylon
    // backpacks and "Maxi" monogram bags are neither.
    if (['sneakers', 'oxfordshoes', 'broguesandoxfords', 'loafers', 'loafersanddrivers', 'boots', 'sandals', 'slidesandsandals', 'dressshoes', 'pumpsandheels', 'balletandflats', 'mules', 'runningshoes', 'traditionalfootwear'].indexOf(category) >= 0 && bagTitle) return false;
    if (rule.tab === 'Lingerie & Nightwear' && /leathergoods|fashionaccessories|watches|luggage/.test(d.type)) return false;
    // Perfume is filed under Fragrances; beauty cards hold the care products.
    if (rule.department === 'beauty' && /\b(edp|edt|eau de (parfum|toilette|cologne)|extrait|body splash|body mist)\b/.test(d.title)) return false;
    if (category === 'fragrance' && !/\b(edp|edt|eau de|parfum|perfume|cologne|extrait|body splash|body mist|attar|oud)\b/.test(d.title) &&
      d.cats.some(function (c) { return ['skincare', 'facemask', 'bathline', 'bodycare', 'haircare', 'handcare', 'oralcare', 'makeup'].indexOf(c) >= 0; })) return false;
    // "Running" alone is not enough: a pen with a "Signature Running Logo"
    // matched. The second test needs an actual footwear word.
    if (category === 'runningshoes') return /\brunning\b|\brunners?\b/.test(d.words + ' ' + d.tags.join(' ')) && /footwear|shoe|sneaker|trainer|\brunners?\b/.test(d.words + ' ' + d.tags.join(' '));
    if (category === 'travelaccessories' && d.tags.some(function (t) { return t === 'luggage travel accessories' || t === 'luggage travel accessories other travel accessories' || t === 'luggage tag'; })) return true;
    if (category === 'sets') {
      // Clothing sets under Women / Men / Kids; perfume gift sets have the
      // Gift Set card under Fragrances.
      if (['women', 'men', 'kids'].indexOf(rule.department) >= 0 && !/fashion$|lingerie/.test(d.type)) return false;
      if (rule.department === 'beauty' && perfume(d)) return false;
      if (/\bsets?\b/.test(d.words + ' ' + d.tags.join(' '))) return true;
    }
    if (category === 'shirtsandblouses' && /\bt shirts?\b|\bpolo\b/.test(d.words)) return d.cats.indexOf(category) >= 0;
    if (category === 'shirts' && /\bt ?shirts?\b|\bpolo\b|\bovershirts?\b/.test(d.words)) return d.cats.indexOf('shirts') >= 0;
    if (wanted.some(function (w) { return d.cats.indexOf(w) >= 0; })) return true;
    /* Other meaningful tags qualify only as a complete label or a
       department-prefixed label, never by substring in an internal SKU. */
    if (tagMeans(d, wanted)) return true;
    // A "belted kimono" or "shawl robe" is clothing: accessory cards take
    // clothing only when its own tag says so (checked above).
    if (['belts', 'scarves', 'capsandhats', 'hats', 'hairaccessories', 'sunglasscases'].indexOf(category) >= 0 &&
      (/fashion$|lingerie/.test(d.type) || /\b(gowns?|robes?|kimonos?|dress(es)?|coats?|jackets?|trousers?|pyjamas?|kaftans?|abayas?|tops?|shirts?)\b/.test(d.title))) return false;
    /* Words place a product by its title only, never its URL handle: handles
       are often left over from an earlier product ("...-loafer" on a
       sneaker). Kids and luggage also read their descriptive tags. */
    var looksAt = rule.department === 'kids' || rule.department === 'luggage' ? d.titleWords + ' ' + d.tags.join(' ') : d.titleWords;
    if (category === 'tops' && rule.department !== 'kids') return false;
    // "Suit" means a tailored suit on the Blazers card - not a jogging,
    // track, swim or lounge suit, nor a pyjama "suit set".
    if (category === 'blazers' && !/\bblazers?\b/.test(d.titleWords) &&
      /\b(jogging|track|swim|jump|play|body|sweat|sleep|lounge|pyjamas?|pajamas?|ski|wet)\s*suits?\b|\bsets?\b/.test(d.titleWords)) return false;
    // Outside Kids, "Bags & accessories" holds the accessories only; the bags
    // already have their own cards in the Bags tab.
    if (category === 'bagsandaccessories' && rule.department !== 'kids') return /\bpouch(es)?\b|\bcosmetic bags?\b|\bbeauty bags?\b|\bempty bags?\b|\bwatch box(es)?\b|\bphone (bag|case|pouch)\b|\bstrap sets?\b|\bluggage tags?\b|\bpassport (covers?|holders?)\b/.test(d.words);
    // Luggage-brand totes and handbags sit with the shoulder bags in Luggage & Travel.
    if (category === 'shoulderbags' && rule.department === 'luggage' && /\bhand ?bags?\b|\btotes?\b/.test(d.title)) return true;
    /* Kids: Baby & Newborn and Kids & Teens split by the product's own age
       tags, so a teen's jeans never land on the baby Pants card. */
    if (rule.department === 'kids' && (rule.tab === 'Baby & Newborn' || rule.tab === 'Kids & Teens')) {
      var baby = d.tags.some(function (t) { return /\bbaby\b|new ?born|infant|\(\d+m/.test(t); });
      // "Kids and Teens" is on baby items too; the age-range tags are not.
      var older = d.tags.some(function (t) { return /kids (boys|girls) \(|\d+ ?yrs/.test(t); });
      if (rule.tab === 'Baby & Newborn' && older && !baby) return false;
      if (rule.tab === 'Kids & Teens' && baby && !older) return false;
    }
    // A suitcase naming no size still needs a card: the spinner card takes it.
    if (category === 'spinnersuitcases' && rule.material && !d.cats.some(function (c) { return ['cabin', 'mediumluggage', 'largeluggage', 'extralargeluggage'].indexOf(c) >= 0; }) && /\bluggage\b|\bsuitcases?\b/.test(d.title)) return true;
    return !!fallback[category] && fallback[category].test(looksAt);
  }

  return { key: key, eligible: eligible, matches: matches, info: info };
}));
